// removed by extract-text-webpack-plugin
module.exports = {"layout":"FooterComponent---layout---3PnXb_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[name]---[local]---[hash:base64:5]_0","importLoaders":true,"camelCase":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bb19cd8c","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./client/components/FooterComponent/FooterComponent.vue
// module id = UHSO
// module chunks = 1